import { equalsIgnoreCase } from "./functions";
import constants from "./constants";

function applyMandatoryRatingAgencies(venueWineObject, ratingAgencies) {
  let mandatoryRatingAgencies = getMandatoryRatingAgencies(ratingAgencies);
  if (venueWineObject.attributes.ratings == null) {
    venueWineObject.attributes.ratings = [];
  }
  for (let a = 0; a < mandatoryRatingAgencies.length; a++) {
    const ratingAgencyId = mandatoryRatingAgencies[a].id;
    const defaultRatingValue = mandatoryRatingAgencies[a].default;
    venueWineObject.attributes.ratings.push({
      value: defaultRatingValue,
      ratingAgency: ratingAgencyId,
    });
  }
}

function getMandatoryRatingAgencies(ratingAgencies) {
  var mandatoryRatingAgencies = [];
  ratingAgencies.data.forEach((ratingAgency) => {
    if (ratingAgency.attributes.mandatory === true) {
      var mandatoryRatingAgency = {
        id: ratingAgency.id,
        default: ratingAgency.attributes.default,
      };
      mandatoryRatingAgencies.push(mandatoryRatingAgency);
    }
  });
  return mandatoryRatingAgencies;
}

function calcPurchasePriceAvg(purchasePrices) {
  var priceSum = 0.0;
  if (purchasePrices != null && purchasePrices.length > 0) {
    purchasePrices.forEach((element) => {
      priceSum += element.price;
    });
    priceSum = priceSum / purchasePrices.length;
    priceSum = Math.round(priceSum * 100) / 100;
  }
  return priceSum;
}

function calcPurchasePriceAvgWithCount(
  currentPrice,
  currentCount,
  newCount,
  newPrice,
) {
  if (currentCount + newCount === 0) {
    return currentPrice;
  }
  var newAvg =
    (currentPrice * currentCount + newPrice * newCount) /
    (currentCount + newCount);
  console.log("newAvg", newAvg);
  return Math.round(newAvg * 100) / 100;
}

function roundAmount(num) {
  const s = String(num);
  const decimalIndex = s.indexOf(".");
  if (decimalIndex !== -1) {
    const decimals = s.length - decimalIndex - 1;
    if (decimals > 2) {
      return parseFloat(num.toFixed(1));
    }
  }
  return num;
}

function addSupplierAndPrice(venueWine, newprice, supplier, newCount, supplierArticleNumber, supplierArticleName) {
  if (venueWine.attributes["purchasePrices"] == null) {
    venueWine.attributes["purchasePrices"] = [];
    if (
      venueWine.attributes["purchasePriceAvg"] != null &&
      venueWine.attributes["purchasePriceAvg"] > 0
    ) {
      var existingPriceBody = {
        price: venueWine.attributes["purchasePriceAvg"],
        wineSupplier: supplier["id"],
      };
      venueWine.attributes["purchasePrices"].push(existingPriceBody);
    }
  }
  const foundPurchasePrice = venueWine.attributes["purchasePrices"].find(
    (pp) => pp.price === newprice,
  );
  if (!foundPurchasePrice) {
    var purchasePriceBody = {
      price: newprice,
      wineSupplier: supplier["id"],
    };
    venueWine.attributes["purchasePrices"].push(purchasePriceBody);
  } else {
    foundPurchasePrice.wineSupplier = supplier["id"];
  }

  // Store the supplier article number and name on the purchase price, so
  // the price history shows which article of the supplier this price
  // belongs to (e.g. the vendorArticleNumber from an inbound sheet row).
  if (supplierArticleNumber != null && supplierArticleNumber !== '') {
    if (foundPurchasePrice) {
      foundPurchasePrice.wineSupplierArticleNumber = supplierArticleNumber;
    } else {
      purchasePriceBody.wineSupplierArticleNumber = supplierArticleNumber;
    }
  }
  if (supplierArticleName != null && supplierArticleName !== '') {
    if (foundPurchasePrice) {
      foundPurchasePrice.wineSupplierArticleName = supplierArticleName;
    } else {
      purchasePriceBody.wineSupplierArticleName = supplierArticleName;
    }
  }

  if (venueWine.attributes["purchasePrices"].length > 1) {
    var newAvg = calcPurchasePriceAvgWithCount(
      venueWine.attributes["purchasePriceAvg"],
      venueWine.attributes["amountFloat"],
      parseFloat(newCount),
      newprice,
    );
    venueWine.attributes["purchasePriceAvg"] = newAvg;
  } else {
    venueWine.attributes["purchasePriceAvg"] = calcPurchasePriceAvg(
      venueWine["purchasePrices"],
    );
  }
  return venueWine;
}

function getWineNameNullChecked(title, grapeVariety) {
  if (title == null || title == "" || title.trim() == "") {
    return grapeVariety;
  }
  return title;
}

function matchVenueWineWithEveryColumn(
  identifierKeys,
  offlineVenueWine,
  csvWine,
  identifierMappingObject,
  removeIdentifierFromMatichArrayCallBack,
) {
  var isMatching = true;

  for (var i = 0; i < identifierKeys.length; i++) {
    var identifierKey = identifierKeys[i];

    var venueWineIdentifier =
      constants.IDENTIFIER_TO_VENUE_WINE_KEY[identifierKey];
    if (venueWineIdentifier == null) {
      removeIdentifierFromMatichArrayCallBack(identifierKey);
      continue;
    }

    var identifierCSVColumn = identifierMappingObject[identifierKey];
    var valueA = deepValueOfObject(offlineVenueWine, venueWineIdentifier);
    var valueB = csvWine[identifierCSVColumn];
    // only match if valueB is set
    if (valueB == "not found" || valueB == null || valueB === "") {
      removeIdentifierFromMatichArrayCallBack(identifierKey);
      continue;
    }
    isMatching = matchValues(valueA, valueB);
    if (!isMatching) {
      // console.log('-- NO match for ' + identifierKey + ' ' + stringA + ' ' + stringB);
      return false;
    } else {
      removeIdentifierFromMatichArrayCallBack(identifierKey);
      // console.log('** match ' + identifierKey + ' ' + csvWine[identifierCSVColumn] + ' ' + this.deepValueOfObject(offlineVenueWine, venueWineIdentifier));
    }
  }
  return isMatching;
}
function generateWineNameFromColumns(
  csvWine,
  identifierMappingObject,
  removePrice,
) {
  var wineName = "";
  var values = [];
  for (var key in identifierMappingObject) {
    if (values.indexOf(csvWine[identifierMappingObject[key]]) > -1) {
      continue;
    }
    if (key == "Preis" && removePrice) {
      continue;
    }
    values.push(csvWine[identifierMappingObject[key]]);
    wineName += csvWine[identifierMappingObject[key]] + " ";
  }
  return wineName;
}

function generateWineString(venueWine, stateOfRow) {
  var wineName = "";

  console.log("generateWineString", venueWine, stateOfRow);
  if (stateOfRow == constants.CAN_CREATE_VENUEWINE_WITH_WINE_ID) {
    wineName =
      venueWine.attributes.title +
      ", " +
      venueWine.attributes.year +
      ", (mit Wein ID)";
  } else if (stateOfRow == constants.CAN_CREATE_WINE) {
    wineName =
      venueWine.attributes.title +
      ", " +
      venueWine.attributes.year +
      ", (Wein neu angelegt)";
  } else {
    if (venueWine.attributes != null && venueWine.attributes.wine != null) {
      var wineryName =
        venueWine.attributes.wine.data.attributes.winery &&
        venueWine.attributes.wine.data.attributes.winery.data &&
        venueWine.attributes.wine.data.attributes.winery.data.attributes
          ? venueWine.attributes.wine.data.attributes.winery.data.attributes
              .title
          : "";
      wineName =
        wineryName +
        ", " +
        venueWine.attributes.title +
        ", " +
        venueWine.attributes.year +
        ", " +
        venueWine.attributes.bottleSize.data.attributes.amount;
    } else {
      wineName =
        venueWine.wine.winery.title +
        ", " +
        venueWine.title +
        ", " +
        venueWine.year +
        ", " +
        venueWine.bottleSize.amount;
    }
  }

  return wineName;
}

function matchValues(valueA, valueB) {
  var stringA = valueA;
  var stringB = valueB;

  if (Number.isInteger(valueA) && Number.isInteger(valueB)) {
    valueA = parseInt(valueA);
    valueB = parseInt(valueB);
    return valueA === valueB;
  } else if (valueA == 0 && valueB == 0) {
    return true;
  } else if (valueA && valueB) {
    stringA = stringA.toString().toLowerCase().replace(",", ".").trim();
    stringB = stringB.toString().toLowerCase().replace(",", ".").trim();
    return equalsIgnoreCase(stringA, stringB);
  } else {
    return false;
  }
}

function deepValueOfObject(object, path) {
  var pathArray = path.split(".");
  var value = object;
  pathArray.forEach((path) => {
    if (value == null) {
      return null;
    }
    value = value[path];
  });
  return value;
}

function addNestedStrapiAttributesToObjects(object) {
  var returnObject = {
    data: {
      attributes: {},
    },
  };
  if (typeof object === "object" && !Array.isArray(object) && object !== null) {
    for (var key in object) {
      if (key == "id") {
        returnObject.data.id = object[key];
        continue;
      }
      returnObject.data.attributes[key] = addNestedStrapiAttributesToObjects(
        object[key],
      );
    }
  } else {
    returnObject = object;
  }
  return returnObject;
}

/**
 * Normalize a string for search comparison
 * @param {*} str
 * @returns
 */
function normalizeString(str) {
  if (!str) return "";
  let normalizedString = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return normalizedString.toLowerCase().trim();
}

/**
 * Check if a venueWine matches the search term in any of its relevant fields
 * @param {*} venueWine
 * @param {*} searchTerm - can be a space-separated string to search for multiple terms
 * @returns
 */
function filterVenueWineBySearchTerm(venueWine, searchTerm) {
  if (searchTerm == null || searchTerm.trim() == "") {
    return true;
  }

  // Split by empty space and trim each term
  const searchTerms = searchTerm
    .split(" ")
    .map((term) => normalizeString(term))
    .filter((term) => term !== "");

  // Check if any search term matches any field
  for (const thisFilterText of searchTerms) {
    let shouldBeShown = false;

    if (venueWine.id.toString() === thisFilterText) {
      shouldBeShown = true;
    }

    if (venueWine.attributes.title) {
      if (
        normalizeString(venueWine.attributes.title).includes(thisFilterText)
      ) {
        shouldBeShown = true;
      }
    }
    if (venueWine.attributes.comments) {
      if (
        normalizeString(venueWine.attributes.comments).includes(thisFilterText)
      ) {
        shouldBeShown = true;
      }
    }
    if (venueWine.attributes.articleNumber) {
      if (
        normalizeString(venueWine.attributes.articleNumber).includes(
          thisFilterText,
        )
      ) {
        shouldBeShown = true;
      }
    }
    if (venueWine.attributes.posArticleNumberList) {
      if (
        normalizeString(
          venueWine.attributes.posArticleNumberList.join(" "),
        ).includes(thisFilterText)
      ) {
        shouldBeShown = true;
      }
    }
    if (venueWine.attributes.shelfNumber) {
      if (
        normalizeString(venueWine.attributes.shelfNumber).includes(
          thisFilterText,
        )
      ) {
        shouldBeShown = true;
      }
    }
    if (venueWine.attributes.wine.data) {
      if (venueWine.attributes.wine.data.attributes.winery.data) {
        if (
          normalizeString(
            venueWine.attributes.wine.data.attributes.winery.data.attributes
              .title,
          ).includes(thisFilterText)
        ) {
          shouldBeShown = true;
        }
      }
      if (venueWine.attributes.wine.data.attributes.region.data) {
        if (
          normalizeString(
            venueWine.attributes.wine.data.attributes.region.data.attributes
              .title,
          ).includes(thisFilterText)
        ) {
          shouldBeShown = true;
        }
      }
      if (venueWine.attributes.wine.data.attributes.grapeVariety) {
        if (
          normalizeString(
            venueWine.attributes.wine.data.attributes.grapeVariety.data
              .attributes.title,
          ).includes(thisFilterText)
        ) {
          shouldBeShown = true;
        }
      }
      if (venueWine.attributes.wine.data.attributes.land.data) {
        if (
          normalizeString(
            venueWine.attributes.wine.data.attributes.land.data.attributes
              .title,
          ).includes(thisFilterText)
        ) {
          shouldBeShown = true;
        }
      }
      if (venueWine.attributes.wine.data.attributes.wineType.data) {
        if (
          normalizeString(
            venueWine.attributes.wine.data.attributes.wineType.data.attributes
              .title,
          ).includes(thisFilterText)
        ) {
          shouldBeShown = true;
        }
      }
    }
    if (venueWine.attributes.year) {
      if (venueWine.attributes.year.toString().includes(thisFilterText)) {
        shouldBeShown = true;
      }
    }

    // If this term doesn't match, the venueWine should not be shown
    if (!shouldBeShown) {
      return false;
    }
  }

  // All terms matched
  return true;
}

export {
  applyMandatoryRatingAgencies,
  getMandatoryRatingAgencies,
  calcPurchasePriceAvg,
  roundAmount,
  addSupplierAndPrice,
  getWineNameNullChecked,
  matchVenueWineWithEveryColumn,
  deepValueOfObject,
  matchValues,
  generateWineNameFromColumns,
  generateWineString,
  addNestedStrapiAttributesToObjects,
  normalizeString,
  filterVenueWineBySearchTerm,
};
